<template>
  <frontPage/>
  <RouterView>
    <div class="bug-report">
      <h2>Report Bug</h2>
      <form @submit.prevent="submitBug">
        <label for="contractAddress">Contract Address:</label>
        <input type="text" id="contractAddress" v-model="contractAddress" required>
  
        <label for="bugDescription">Bug Description:</label>
        <textarea id="bugDescription" v-model="bugDescription" required></textarea>
  
        <button type="submit">Submit</button>
      </form>
      <div v-if="isBugSubmitted" class="success-message">
        Bug reported successfully!
      </div>
    </div>
  </RouterView>
  </template>
  
  <script>
  import frontPage from './frontPage.vue';
  export default {
    components: {
    frontPage
  },
    data() {
      return {
        contractAddress: '',
        bugDescription: '',
        isBugSubmitted: false,
      };
    },
    methods: {
      submitBug() {
        // Simulate bug submission
        // Replace this with your actual bug reporting logic
        console.log('Contract Address:', this.contractAddress);
        console.log('Bug Description:', this.bugDescription);
  
        // Clear form fields and show success message
        this.contractAddress = '';
        this.bugDescription = '';
        this.isBugSubmitted = true;
  
        // Reset success message after a delay
        setTimeout(() => {
          this.isBugSubmitted = false;
        }, 3000);
      },
    },
  };
  </script>
  
  <style scoped>
  .bug-report {
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
  }
  
  form {
    display: flex;
    flex-direction: column;
  }
  
  label {
    margin-bottom: 5px;
  }
  
  input,
  textarea {
    margin-bottom: 10px;
  }
  
  button {
    padding: 10px 20px;
  }
  
  .success-message {
    color: green;
    margin-top: 10px;
  }
  </style>
  